import { call, put, takeEvery } from 'redux-saga/effects';
import { get, noop } from 'lodash-es';
import {
  fetch_categories,
  fetch_sub_categories,
  fetch_faq,
  fetch_faq_answers,
  fetch_user_tickets,
} from '../../apis/helpAndSupport';
import {
  fetchCategories,
  setCategories,
  fetchSubCategories,
  setSubCategories,
  fetchFaq,
  setFaq,
  fetchFaqAnswers,
  setFaqAnswers,
  fetchTickets,
  setOpenTickets,
  setClosedTickets,
} from '../reducers/helpAndSupport';
import { setError } from '../reducers/error';
import { setLoader } from '../reducers/loader';

export default function* accountClosureSagas() {
  yield takeEvery(fetchCategories.toString(), handleFetchCategories);
  yield takeEvery(fetchSubCategories.toString(), handleFetchSubCategories);
  yield takeEvery(fetchFaq.toString(), handleFetchFaq);
  yield takeEvery(fetchTickets.toString(), handleFetchTickets);
  yield takeEvery(fetchFaqAnswers.toString(), handleFetchFaqAnswers);
}

function* handleFetchCategories({ payload }) {
  const { Api, token = '', screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const resp = yield call(fetch_categories, Api, token);
    yield put(setCategories(resp));
    yield call(sagaCallback, resp);
  } catch (err) {
    console.error('error is in handleFetchCategories', err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchSubCategories({ payload }) {
  const { Api, categoryId, token = '', screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const resp = yield call(fetch_sub_categories, Api, categoryId, token);
    const result = get(resp, 'sub_categories', []);
    yield put(setSubCategories(result));
    yield call(sagaCallback, result);
  } catch (err) {
    console.error('error is in handleFetchSubCategories', err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchFaq({ payload }) {
  const {
    Api,
    subCategoryId,
    token = '',
    screen,
    sagaCallback = noop,
  } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const resp = yield call(fetch_faq, Api, subCategoryId, token);
    const faqs = get(resp, 'faqs', []);
    yield put(setFaq(faqs));
    yield call(sagaCallback, faqs);
  } catch (err) {
    console.error('error is in handleFetchFaq', err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchFaqAnswers({ payload }) {
  const { Api, faqId, token = '', screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const resp = yield call(fetch_faq_answers, Api, faqId, token);
    const faqAns = get(resp, 'faq', []);
    yield put(setFaqAnswers(faqAns));
    yield call(sagaCallback, faqAns);
  } catch (err) {
    console.error('error is in handleFetchFaqAnswers', err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}

function* handleFetchTickets({ payload }) {
  const { Api, status, token = '', screen, sagaCallback = noop } = payload;
  try {
    yield put(setLoader({ screen, isPageLoading: true }));
    yield put(
      setError({
        screen,
        isFetchFailed: false,
        isUpdateFailed: false,
        message: '',
      })
    );
    const resp = yield call(fetch_user_tickets, Api, status, token);
    const tickets = get(resp, 'tickets', []);
    if (status === 'open') {
      yield put(setOpenTickets(tickets));
    } else if (status === 'closed') {
      yield put(setClosedTickets(tickets));
    }
    yield call(sagaCallback, tickets);
  } catch (err) {
    console.error('error is in handleFetchTickets', err);
    yield put(setError({ screen, isFetchFailed: true, message: err.message }));
  } finally {
    yield put(setLoader({ screen, isPageLoading: false }));
  }
}
